import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: "naFilter",
    standalone: false
})
export class NAFilterPipe implements PipeTransform {
    transform(input: any): number | null {
        if ( input == null || input.toString() == '' ||Number.isNaN(Number(input))) {
            return null;
        }
        return Number(input);
    }
}

@Pipe({
    name: "naUnfilter",
    standalone: false
})
export class NAUnfilterPipe implements PipeTransform {
    transform(input: any): string {
        if (input == null) {
            return  'N/A';
        }
        return input.toString();
    }
}